// extracted by mini-css-extract-plugin
export default {"loading_page":"OverlayLoading_loading_page__WDiw7"};